@if (request) {
  <div class="content-container" [class]="request.type">
    @if (request.type == PaymentRequestType.private) {
      <app-header></app-header>
    }
    <div class="content">
      @if (request.status == PaymentRequestStatus.open) {
        <div>
          <div class="payment-header">
            <div class="payment-header-left">
              <p class="requestor-name">{{ request.requestorName }}</p>
              <p class="payment-description">{{ request.description }}</p>
            </div>
            <img class="ideal-logo" ngSrc="assets/images/ideal-wero.svg" alt="iDEAL Wero" height="40" width="104" />
          </div>
          <router-outlet (activate)="onOutletLoaded($event)"></router-outlet>
        </div>
      }
      @if (request.status != PaymentRequestStatus.open) {
        <app-payment-request-status [paymentRequestStatus]="request.status"></app-payment-request-status>
      }
    </div>
    @if (request.type == PaymentRequestType.private) {
      <img id="blob-right" src="assets/images/blob-right.svg" alt="blob" width="256px" height="134px" role="presentation" />
    }
  </div>
}
